"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function BackuppoliciesGreyMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__backuppolicies-grey-multitone-filled__clip0_14202_8773)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M3.23 10.929a2.86 2.86 0 01-1.32-5.384 2.924 2.924 0 01-.149-.913 2.848 2.848 0 012.833-2.856c.343 0 .684.066 1.004.192A4.489 4.489 0 019.03.4a4.56 4.56 0 014.536 4.576v.348a2.856 2.856 0 012.032 2.749 2.734 2.734 0 01-2.712 2.84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M7.23 10.929c-.108.02-3.016.032-3.124.044-2.348.26-3.709-1.396-3.709-2.9A2.876 2.876 0 011.91 5.545a2.924 2.924 0 01-.148-.913 2.848 2.848 0 012.832-2.856c.344 0 .684.066 1.004.192A4.489 4.489 0 019.03.4a4.56 4.56 0 014.44 3.624"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M3.23 11.329A3.26 3.26 0 011.444 5.36a3.2 3.2 0 01-.084-.728 3.232 3.232 0 014.133-3.128A4.9 4.9 0 019.03 0a4.965 4.965 0 014.936 4.976v.064A3.28 3.28 0 0116 8.073a3.144 3.144 0 01-3.113 3.24.4.4 0 010-.8 2.328 2.328 0 002.313-2.44 2.46 2.46 0 00-1.773-2.365.4.4 0 01-.288-.4v-.316A4.16 4.16 0 009.03.8a4.116 4.116 0 00-3.116 1.428.4.4 0 01-.448.112 2.4 2.4 0 00-.872-.164A2.448 2.448 0 002.16 4.632c0 .272.043.542.128.8a.4.4 0 01-.188.48A2.456 2.456 0 003.23 10.53a.4.4 0 110 .8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M11.13 15.75H5.15a1.004 1.004 0 01-1-.997V6.777a1.004 1.004 0 011-.996h4.984l2 2v6.972a1 1 0 01-1.004.996z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M4.15 14.753V6.777a1.004 1.004 0 011-.997h4.984l2.348-.668"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.142 11.137a.46.46 0 100 .92.46.46 0 000-.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M10.102 11.241h-.22a1.832 1.832 0 00-.22-.552l.148-.148a.4.4 0 00-.564-.564l-.136.136a1.751 1.751 0 00-.568-.24v-.188a.4.4 0 10-.8 0v.188c-.2.046-.391.128-.564.24l-.136-.136a.4.4 0 10-.568.564l.152.148c-.106.17-.183.357-.228.552h-.22a.4.4 0 100 .8h.24c.047.186.124.363.228.524l-.18.18a.4.4 0 00.13.653.4.4 0 00.438-.085l.192-.196c.157.095.329.163.508.204v.28a.4.4 0 00.8 0v-.28c.18-.04.354-.109.512-.204l.192.192a.4.4 0 10.564-.564l-.176-.18c.104-.161.181-.338.228-.524h.24a.4.4 0 100-.8h.008zm-2.568 1.12a.976.976 0 01.592-1.736h.036a.972.972 0 01.956.976.96.96 0 01-.368.764.984.984 0 01-1.216-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M10.134 5.78H5.149a1.004 1.004 0 00-1 .997v7.976a1.004 1.004 0 001 .996h5.981a1 1 0 00.996-.996V7.777L10.134 5.78zm.86 2h-.86v-.867l.86.868zm.332 6.977a.2.2 0 01-.196.196H5.15a.2.2 0 01-.2-.196v-7.98a.204.204 0 01.2-.196h4.184v1.2a.8.8 0 00.8.8h1.2l-.008 6.176z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__backuppolicies-grey-multitone-filled__clip0_14202_8773"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

BackuppoliciesGreyMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
BackuppoliciesGreyMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = BackuppoliciesGreyMultitoneFilled;
exports["default"] = _default;